import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';

const LocaleContext = createContext();
const LocaleActionsContext = createContext();

export const useLocaleContext = () => useContext(LocaleContext);

export const useLocaleActionsContext = () => useContext(LocaleActionsContext);

const LocaleContextProvider = ({children}) => {
  const defaultConfig = {
    locale: {
      languageId: 'english',
      locale: 'en',
      name: 'English',
      icon: 'us',
    },
  };
  const [locale, updateLocale] = useState(defaultConfig.locale);

  return (
    <LocaleContext.Provider
      value={{
        locale,
      }}>
      <LocaleActionsContext.Provider
        value={{
          updateLocale,
        }}>
        {children}
      </LocaleActionsContext.Provider>
    </LocaleContext.Provider>
  );
};

export default LocaleContextProvider;

LocaleContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
